function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#9F9AAD",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.026 10.158a6.25 6.25 0 0 1-6.567 3.773 6.26 6.26 0 0 1-5.383-5.333 6.269 6.269 0 0 1 3.69-6.624.509.509 0 0 0-.405-.931A7.285 7.285 0 0 0 1.072 8.74a7.274 7.274 0 0 0 6.256 6.199 7.264 7.264 0 0 0 7.632-4.386.507.507 0 1 0-.934-.396z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 7.478A7.478 7.478 0 0 0 8.522 0 .522.522 0 0 0 8 .522v6.956c0 .288.234.522.522.522h6.956A.522.522 0 0 0 16 7.478zm-6.957-.521V1.065a6.435 6.435 0 0 1 5.892 5.892H9.043z"
}));

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.22ace7c1.svg";
export { ForwardRef as ReactComponent };